export default {
  warning: {
    summary: 'Nepodporované zloženie materiálu',
    details: 'Výpočet diagramov ARA je momentálne obmedzený na materiály, v ktorých je hmotnostné percento všetkých prvkov menšie ako {threshold}.',
  },
};
